import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_PRODUCT,
  DELETE_PRODUCT,
  GET_PRODUCTS,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_STATUS
} from "./actionTypes";

import {
  addProductFail,
  addProductSuccess,
  deleteProductFail,
  deleteProductSuccess,
  getProductsFail,
  getProductsSuccess,
  setState,
  updateProductFail,
  updateProductSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { products, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchProducts({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, products, params.toString());
    yield put(setState(false));
    yield put(getProductsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getProductsFail(error));
  }
}

function* updateProduct({ payload: productObj }) {
  try {
    const { id, recordStatus, ...rest } = productObj;
    yield call(patchApiCall, `${products}/${id}`, rest);
    const response = yield call(getTable, `${products}/${productObj.id}`);
    yield put(updateProductSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateProductFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateProductStatus({ payload: productObj }) {
  try {
    const { id } = productObj;
    yield call(patchApiCall, `${products}/${updateStatus}/${id}`, { recordStatus: productObj.recordStatus });
    const response = yield call(getTable, `${products}/${productObj.id}`);
    yield put(updateProductSuccess(response));
  } catch (error) {
    yield put(updateProductFail(error));
  }
}

function* deleteProduct({ payload: productObj }) {
  try {
    yield call(deleteApiCall, `${products}/${productObj.id}`);
    yield put(deleteProductSuccess(productObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteProductFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingProduct({ payload: product }) {
  try {
    const response = yield call(postApiCall, products, product);
    const response2 = yield call(getTable, `${products}/${response.id}`);
    yield put(addProductSuccess(response2));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addProductFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* productsSaga() {
  yield takeEvery(GET_PRODUCTS, fetchProducts);
  yield takeEvery(ADD_NEW_PRODUCT, postingProduct);
  yield takeEvery(UPDATE_PRODUCT, updateProduct);
  yield takeEvery(UPDATE_PRODUCT_STATUS, updateProductStatus);
  yield takeEvery(DELETE_PRODUCT, deleteProduct);
}

export default productsSaga;